export { setVirtualParent } from '@fluentui/dom-utilities';
